import { Stack, Text, textVariants } from '@etg/wings';
import { Notification, variants } from '@eti/components';
import { useTranslation } from '@eti/providers';
import RyanairFlightInfoBox from '../../common/RyanairFlightInfoBox';
import TopicsContentWrapper from '../TopicsContentWrapper';
import FaqSection from '../../common/FaqSection';
import { useOrderDetails } from '../../../containers/OrderDetailsContext';

interface ContactRyanairContentProps {
  faqSectionSlug: string;
}

const ContactRyanairContent = ({ faqSectionSlug }: ContactRyanairContentProps) => {
  const { t } = useTranslation();
  const { faqSectionPerSlug } = useOrderDetails();

  return (
    <TopicsContentWrapper
      leftColumnContent={
        <Stack spacing={24}>
          <Stack spacing={8}>
            <Text variant={textVariants._16_BOLD}>
              {t('OrderDetails.RyanairFlight.InfoBox.Title')}
            </Text>
            <RyanairFlightInfoBox isExpanded={false} />
          </Stack>
          {faqSectionPerSlug?.[faqSectionSlug] && (
            <FaqSection
              headingAs="h5"
              headingLevel={4}
              padding={0}
              section={faqSectionPerSlug[faqSectionSlug]}
            />
          )}
        </Stack>
      }
      rightColumnContent={
        <Notification dataTestId="no-contact-us-notification" variant={variants.WARNING}>
          <Text asHtml>{t('ContactUs.NoContact.Notification.Content')}</Text>
        </Notification>
      }
      shouldShowContactMethods={false}
    />
  );
};

export default ContactRyanairContent;
